export class SelectTaskEval {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get task() {
        return this.parent;
    }
    get isComplete() {
        if (this.task.options.length === 0)
            return false;
        return !this.task.options.find(option => !option.isSelected && option.shouldBeSelected);
    }
    get isWronglySelected() {
        return !!this.task.options.find(option => option.isSelected && !option.shouldBeSelected);
    }
    get isCorrectlySelected() {
        return this.isComplete && !this.isWronglySelected;
    }
}
